const o=o=>"string"==typeof o&&"svg"===o.toLowerCase();export{o as isSVGTag};
